import { render } from "./JudgeBadgeMini.vue?vue&type=template&id=72d74278&ts=true"
import script from "./JudgeBadgeMini.vue?vue&type=script&lang=ts"
export * from "./JudgeBadgeMini.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__